module.exports = __webpack_public_path__ + "img/template27_mobile.cd9237fe.png";